import { info } from "console"
import { StaticImage } from "gatsby-plugin-image"

import { blogUrl } from "../../services/blogLinks"

const openTextPremagicData = {
  color: "#eaf7ffff",
  heroTitle: `Driving 70% higher booth footfall at trade shows | How OpenText cracked the code for higher attendee engagement`,
  heroImage: (
    <StaticImage
      src="../../images/case-study/opentext/hero.png"
      alt="khaleej-times-uae-media-event-photo-case-study.png"
    />
  ),
  metrics: {
    quote: `<div style='text-align: left'>OpenText partnered with Premagic to replace old-school photo booths with interactive avatars at their events. By blending personalization, gamification, and trend-based activations, OpenText achieved:
</div>
<div style='text-align:left;'>
  <br/>
  <ul style='list-style:disc'>
    <li><b>70%+ participation rate</b> across events</li>
    <li><b>700+ avatars</b> created at a single summit</li>
    <li><b>Hundreds of LinkedIn interactions</b> through gamified contests</li>
    <li><b>Personalized swag</b> that turned into memorable keepsakes</li>
    <li><b>Positioned themselves as an innovator</b> in event engagement</li>
  </ul>
</div>`,
  },
  //   images: [
  //     {
  //       img: (
  //         <StaticImage
  //           src="../../images/case-study/khaleej-times/hero.png"
  //           alt="Sponsors"
  //         />
  //       ),
  //     },
  //     {
  //       img: (
  //         <StaticImage
  //           src="../../images/case-study/khaleej-times/gallery.png"
  //           alt="AGC"
  //         />
  //       ),
  //     },
  //     {
  //       img: (
  //         <StaticImage
  //           src="../../images/case-study/khaleej-times/avatars.png"
  //           alt="Avatars"
  //         />
  //       ),
  //     },
  //   ],
  gallery: (
    <StaticImage
      src="../../images/case-study/opentext/gallery.png"
      alt="opentext-case-study-gallery"
    />
  ),
  caseStudyData: [
    {
      title: "Introduction",
      info1: `<a href='https://www.opentext.com/'>OpenText</a> a global leader in cloud and AI solutions, powers B2B events for over 120,000 enterprise customers across 180 countries, including 98 of the world’s top 100 companies. With events at the core of their engagement strategy, they’re constantly looking for new ways to make attendee experiences personal and memorable.`,
    },
    {
      title: "The Challenge",
      info1: `Exhibitors at B2B events often struggle to stand out. Photo booths and generic swag don’t cut it anymore—attendees expect something that creates high recall value and is fun and more share-worthy.<br/><br/>OpenText wanted to solve this challenge at their upcoming field marketing events. Their goal: <b>drive engagement at the booths, give attendees a memorable keepsake, and create content that spreads beyond the venue.</b>`,
    },
    {
      title: "The Premagic solution: Personalized avatars at scale",
      video: `https://youtube.com/shorts/ZdKTbjFlH8E?si=g60N3fJa9KLu2UmV`,
      info2: `<a href='https://premagic.com/avatar-studio/?utm_source=casestudy&utm_medium=website&utm_id=opentext'>Premagic’s avatars</a> are digital, personalized illustrations created from an attendee’s selfie. It is designed to be fun, shareable and highly customizable with brand elements.<br/><br/>They can turn a simple interaction into a highly personal experience, encourage organic social sharing, and offer a modern alternative to photo booths that actually drives measurable engagement. The setup process is straightforward: attendees clicked a selfie at the booth, selected an avatar style, and within seconds, received their personalized avatar via WhatsApp and email.<br/><br/><a href='https://www.youtube.com/shorts/xi-GPZw3gAA'>CHECK OUT HOW IT WORKS</a><br/><br/>In 2024–25, OpenText used <a href='${blogUrl("avatarStudio")}'>Premagic avatars</a> at more than <b>eight events globally</b>, including summits and meetups across India, Saudi Arabia and Africa. Each of these events brought together 300-400 attendees.<br/><br/>Here’s how they elevated the avatar experience for their attendees:<br/><br>`,
    },
    {
      subheading: `1.Avatar booths instead of photo booths`,
      image: (
        <StaticImage
          src="../../images/case-study/opentext/booths.png"
          alt="khaleej-times-uae-media-event-photo-case-study-testimonial"
        />
      ),
      imagePosition: "top",
      info2: `Avatar booths replaced old-school photo booths, allowing attendees to create personalized avatars instantly.<br/><br/>Attendees loved the idea of seeing themselves as custom characters rather than simply framed photos. This personalization ensured steady booth traffic and personalized takeaways that attendees actually valued.<br/><br/><b>Why it matters for organizers:</b> Interactive, branded avatars feel fresh and modern, giving exhibitors a more impactful way to engage with attendees while reinforcing event branding and increasing footfall.<br/><br/>Looking to replace outdated photo booths at your next event? <br/><br/><a href='https://premagic.com/request-a-demo/?utm_source=casestudy&utm_medium=website&utm_id=opentext'>Book a demo</a> today and see how avatars can drive higher engagement. `,
    },
    {
      subheading: "2.LinkedIn Avatar Gamification for pre-event buzz",
      info2: `<a href='https://www.linkedin.com/posts/neeraj-ahuja-36667924_techsabha-cybersecurity-observability-activity-7298336894713561090-dyJH?utm_source=social_share_send&utm_medium=android_app&rcm=ACoAAAyv43AB2SgoUYzzBw_tKdC9nckUJC8orn8&utm_campaign=copy_link'>View the post</a><br/><br/>OpenText ran an avatar contest on LinkedIn. Attendees were invited to create their avatars, post them online with a branded hashtag, and enter a draw to win an Apple Watch.<br/><br/>The contest not only encouraged social sharing but also extended the event’s visibility beyond its physical walls. The activation generated hundreds of avatar posts, amplifying OpenText’s presence on social platforms and sparking organic conversations about their events.<br/><br/>Why it matters for organizers: Pre-event gamification builds momentum, increases exhibitor visibility, and amplifies organic reach—turning attendees into marketers before the event begins.<br/><br/>Related Read: <a href='${blogUrl("saudiEventShow")}'>Premagic Avatars - a crowd-pleaser at Saudi Event Show</a>`,
      imagePosition: "center",
      image: (
        <StaticImage
          src="../../images/case-study/opentext/linkedin-post.png"
          alt="khaleej-times-uae-media-event-photo-case-study-fomo"
        />
      ),
    },
    {
      //   title: "Results: Transforming attendees into brand advocates",
      subheading: `3. Turning avatars into personalized swag`,
      info2: `Avatars weren’t just digital. Open Text exhibitors offered live-printed avatar-based merchandise —mugs, T-shirts, and posters featuring each attendee’s avatar. Instead of generic swag, each attendee left with keepsakes unique to them.<br/><br/><b>Why it matters for organizers: </b> Personalized merch has higher retention value than standard giveaways, creating brand recall long after the event ends.<br/><br/>Discover how personalized merch and avatars can create lasting brand recall. <br/><br/><a href='https://premagic.com/request-a-demo/?utm_source=casestudy&utm_medium=website&utm_id=opentext'>Talk to our team</a> to explore options.`,
      imagePosition: "center",
      image: (
        <StaticImage
          src="../../images/case-study/opentext/post-swag.png"
          alt="khaleej-times-uae-media-event-photo-case-study-agc"
        />
      ),
    },
    {
      subheading: "4. Riding cultural moments to go viral",
      info2: `When Studio Ghibli–style portraits were trending online, OpenText worked with Premagic to create a custom <b>Ghibli avatar</b> filter, developed in under two weeks.<br/><br/>Attendees eagerly shared their Ghiblified versions online, giving the event a viral lift.<br/><br/><b>Why it matters for organizers:</b> Event engagement doesn’t have to stop at the booth. Leveraging trends makes your content more shareable, increasing reach far beyond attendees.`,
      image: (
        <StaticImage
          src="../../images/case-study/opentext/riding-culture.png"
          alt="khaleej-times-uae-media-event-photo-case-study-sponsor"
        />
      ),
      imagePosition: "top",
    },
    {
      subheading: "5. A modern spin on event branding",
      info2: `After creating their avatars, attendees could further personalize them by selecting categories of interest, such as DevOps, Cloud Security, or Content Management. These labels were integrated into their avatars, which were then printed on a card featuring the attendee’s name and a small OpenText branding message or visual. <br/><br/>Attendees left with a branded keepsake that reinforced both their participation and the company’s messaging.<br/><br/><b>Why it matters for organizers:</b> Using avatars as branded takeaways modernizes event activations and ensures lasting visibility for sponsors or exhibitors while providing a fresh and memorable alternative to traditional brochures or flyers.<br/><br/>Related Read: <a href=''>Check out how IDC used photos, posters and avatars to drive social sharing at their events
        </a>`,

      image: (
        <StaticImage
          src="../../images/case-study/opentext/spin-event.jpg"
          alt="khaleej-times-uae-media-event-photo-case-study-avatar"
        />
      ),
      imagePosition: "top",
    },
    {
      subheading: "6. Leaderboards for engagement",
      info2: `At in-person events, OpenText used booth TV screens to display leaderboards highlighting top interactions and referrals. Winners were celebrated with real-time shoutouts and on-screen confetti, adding excitement and friendly competition.<br/><br/><b>Why it matters for organizers:</b>: Gamification encourages higher attendee participation, keeps energy levels high at the booth, and creates memorable, shareable experiences that extend the event’s impact.
`,
      image: (
        <StaticImage
          src="../../images/case-study/opentext/leaderboard.png"
          alt="gallery"
        />
      ),
      imagePosition: "top",
    },
    {
      subheading: "7. Cultural inclusivity through avatars",
      info2: `OpenText India used Ghibli-themed avatars at Marketing Mojo, a virtual team-building event. Attendees could choose India-themed avatars that reflected local culture, allowing employees across the globe to participate in a shared, culturally relevant experience<br/><br/><b>Why it matters for organizers: </b>Hybrid-friendly activations let remote participants feel included and connected, creating a unified experience that strengthens engagement and company culture, no matter where attendees are located.

`,
      image: (
        <StaticImage
          src="../../images/case-study/opentext/cultural.png"
          alt="gallery"
        />
      ),
      imagePosition: "top",
    },
    {
      title: "The Impact",
      info1: `
    <ul style='list-style: disc; padding-left: 20px'>
      <li><b>Higher booth engagement:</b> At MachineCon, 130 avatars were created by 95 attendees. At the CIO Leader’s Awards, 222 avatars were generated by 170 attendees. At OpenText Summit Saudi Arabia, a whopping 713 avatars were created by 256 attendees. This translates to over a 70% participation rate—far exceeding typical photo booth engagement averages.</li>
      <li><b>Extended social visibility:</b> The LinkedIn contest and avatar sharing boosted organic reach beyond the event floor, generating hundreds of interactions.</li>
      <li><b>Memorable takeaways:</b> Personalized mugs, posters, and avatars ensured attendees left with unique keepsakes, improving brand recall and creating lasting impressions.</li>
      <li><b>Innovation perception:</b> OpenText positioned itself as an innovator in event activations, standing out from competitors with modern, interactive experiences.</li>
    </ul>
  `,
      info2: `Want to turn attendee content into organic visibility? <br/><br/> <a href='https://premagic.com/request-a-demo/?utm_source=casestudy&utm_medium=website&utm_id=opentext'>Try Premagic avatars</a> for your next event activation.<br/><br/>
    <b>Key takeaways for event organizers</b><br/><br/>
    <b>Avatars are the new photo booth:</b> they provide personalization, creativity, and social shareability.<br/><br/>
    <b>Gamification works:</b> combining contests and leaderboards with avatars keeps attendees engaged.<br/><br/>
    <b>Trend-riding is powerful:</b> the Ghibli avatar proved how quickly adapting to viral trends can spark excitement.<br/><br/>
    <b>Personalized merch > brochures:</b> attendees value keepsakes that feel unique and relevant.
  `,
      image: (
        <StaticImage
          src="../../images/case-study/opentext/impact.png"
          alt="impact"
        />
      ),
    },
    {
      title: "The Future plans",
      info1: `OpenText plans to continue using Premagic avatars at upcoming events, experimenting with new categories, merchandise options, and trend-inspired styles. With avatars proving to be a versatile engagement tool, both online and offline, OpenText is committed to making them a core part of its global event strategy.<br/><br/>Ready to give your attendees something more memorable than a photo booth? <a href='https://premagic.com/request-a-demo/?utm_source=casestudy&utm_medium=website&utm_id=opentext'>Let’s talk.</a>
`,
    },
  ],
  isCTAActive: true,
}

export default openTextPremagicData
